function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.9166666666666666s",
  repeatCount: "indefinite"
}));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(30 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8333333333333334s",
  repeatCount: "indefinite"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(60 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.75s",
  repeatCount: "indefinite"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6666666666666666s",
  repeatCount: "indefinite"
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5833333333333334s",
  repeatCount: "indefinite"
}));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(150 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5s",
  repeatCount: "indefinite"
}));

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.4166666666666667s",
  repeatCount: "indefinite"
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(210 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.3333333333333333s",
  repeatCount: "indefinite"
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.25s",
  repeatCount: "indefinite"
}));

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.16666666666666666s",
  repeatCount: "indefinite"
}));

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(300 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.08333333333333333s",
  repeatCount: "indefinite"
}));

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 26,
  rx: 3.36,
  ry: 1.82,
  width: 4,
  height: 14,
  fill: "current",
  transform: "rotate(330 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-spinner",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default __webpack_public_path__ + "static/media/loading-spinner.bb826fbf.svg";
export { SvgComponent as ReactComponent };